import { useState } from "react";
import { Grid, Box, MenuItem, Button } from '@mui/material';
import { TextField } from '@mui/material';
import MainCard from './MainCard';
import { gridSpacing } from '../../store/constant';
import axios from "../../components/axios";
import { useNavigate } from 'react-router-dom';


const AddFileLimitForm = ({ triggerFunctions }) => {
    const navigate = useNavigate();
    const fileDirections = [
      {
        value: 'u',
        label: 'Upload',
      },
      {
        value: 'd',
        label: 'Download',
      },
    ];

    const styleButton = {
      marginTop: "40px",
      backgroundColor: "#406599",
      color: "#fff",
      borderRadius: "5px",
      boxSizing: "border-box",
      width: "100px",
      height: "45px",
      fontFamily: '"Roboto", "sans-serif"',
      fontSize: "15px",
    };

    const [hardware, setHardware] = useState("");
    function handleHardware(e) {
        setHardware(e.target.value);
    }

    const [userAgent, setUserAgent] = useState("");
    function handleUserAgent(e) {
        setUserAgent(e.target.value);
    }

    const [bucket, setBucket] = useState('');
    const handleBucket = (event) => {
        setBucket(event.target.value);
    };

    const [filePrefix, setFilePrefix] = useState('');
    const handleFilePrefix = (event) => {
        setFilePrefix(event.target.value);
    };

    const [fileDirection, setFileDirection] = useState('');
    const handleFileDirection = (event) => {
        setFileDirection(event.target.value);
    };

    const [triggerFunc, setTriggerFunc] = useState('');
    const handleTriggerFunc = (event) => {
        setTriggerFunc(event.target.value);
    };

    const [limitIP, setLimitIP] = useState('');
    const handleLimitIP = (event) => {
        setLimitIP(event.target.value);
    };

    const handleCreateLimit = async () => {
      if (hardware === "" || userAgent === "" || bucket === "" || fileDirection === ""){
        alert("Please enter hardware, bucket, user agent and select direction !");
      }else{
        var input_data = JSON.stringify({ hardware: hardware, user_agent: userAgent, 
          bucket: bucket, prefix: filePrefix, direction: fileDirection, trigger: triggerFunc, limit_ip: limitIP });

        axios.post("/peloton/v1/automation/create-limit",input_data,{withCredentials: true})
        .then(response => {
            if (response.data.message === "success") {
                setHardware('');
                setUserAgent('');
                setBucket('');
                setFilePrefix('');
                setFileDirection('');
                setTriggerFunc('');
                setLimitIP('');
            }else{
                alert(response.data.message);
            }
        }).catch(function(err){
          if (!err.response){
            alert(err);
          }else{
            if (err.response.status === 401){
              alert(err.response.data.message);
              navigate("/");
            }else{
                console.log('error.response.status: ', err.response.status)
                console.log('error.response.status: ', err.response.data.message)
                alert(err.response.data.message)
            }
          }
        })
      }
    };

    return (
    <MainCard title="S3 buckets config">
        <Box sx={{ maxWidth: '100%'}}>
        <Grid container spacing={gridSpacing} justifyContent="center" rowSpacing={gridSpacing} columnSpacing={gridSpacing}>
        <Grid item xs={6}>
        <TextField
              required
              fullWidth
              id="file-hardware"
              label="Hardware"
              value={hardware}
              onChange={handleHardware}
              variant="filled"
          />
          </Grid>
          <Grid item xs={6}>
            <TextField
              required
              id="file-agent"
              fullWidth
              label="User Agent"
              value={userAgent}
              onChange={handleUserAgent}
              variant="filled"
            >
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              required
              id="file-bucket"
              fullWidth
              label="Bucket name"
              value={bucket}
              onChange={handleBucket}
              variant="filled"
            >
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="file-prefix"
              fullWidth
              label="File Prefix"
              value={filePrefix}
              onChange={handleFilePrefix}
              variant="filled"
            >
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="file-ip"
              fullWidth
              label="Limit IP"
              value={limitIP}
              onChange={handleLimitIP}
              variant="filled"
            >
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              id="user-tools"
              select
              fullWidth
              label="File Direction"
              value={fileDirection}
              onChange={handleFileDirection}
            >
              {fileDirections.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="user-upload"
              select
              fullWidth
              label="Trigger Function"
              value={triggerFunc}
              onChange={handleTriggerFunc}
            >
              {triggerFunctions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          </Grid>
          <Grid container spacing={gridSpacing} justifyContent="flex-end">
          <Grid item>
          <Button style={styleButton} onClick={handleCreateLimit}>Send</Button>
          </Grid>
          </Grid>
          </Box>
      </MainCard>
    );
};

export default AddFileLimitForm;
